import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { useDispatch } from "react-redux";
import GlobalStyles from "./styles/globalStyles";
import { defaultTheme } from "./constants";
import HomeFilter from "./layouts/HomeFilter";

interface Props {
  origin: string;
  data: string;
}

function App() {
  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];
  const dispatch = useDispatch();

  const params = new URLSearchParams(window.location.search);
  const country = params.get("country");

  const isAllowedOrigin = (origin: string) => {
    const supportedOrigins = [
      "localhost:3000",
      "fp.local",
      "flashpicks.com",
      // re-platform generated url support
      "checkd-blogs-v3",
      // re-platform prod url support
      "fp.checkd-media",
      // replatform staging url support
      "fp.test.checkd-media",
      // replatform dev url support
      "fp.dev.checkd-media",
    ];

    return supportedOrigins.some((allowedOrigin) =>
      origin.includes(allowedOrigin)
    );
  };

  useEffect(() => {
    const receiveMessage = (event: Props) => {
      // check if the origin is allowed and the repo is not running locally
      // to prevent a loop of messages
      if (
        window.location.host === "localhost:3000" ||
        !isAllowedOrigin(event.origin)
      ) {
        return;
      }
      const received = JSON.parse(event.data);

      if (received.type === "SET_ACTIVE_ODDS_FORMAT") {
        dispatch({
          type: received.type,
          payload: received.oddsFormat.toLowerCase(),
        });
      } else if (received.type === "SET_BEST_ODDS") {
        dispatch({
          type: received.type,
          payload: received.bestOdds,
        });
      } else {
        dispatch({
          type: received.type,
          payload: received.betslip,
        });
      }
    };

    window.addEventListener("message", receiveMessage, false);
    window.parent.postMessage(
      {
        type: "IFRAME_LOADED",
      },
      parentURL
    );

    return () => window.removeEventListener("message", receiveMessage, false);
  }, [dispatch, parentURL]);

  return (
    <>
      <GlobalStyles />
      <ThemeProvider theme={defaultTheme}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={<HomeFilter countryCode={country ? country.toUpperCase() : null} />}
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
